var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinLogoV2 = function SvgLinkedinLogoV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    fillRule: "evenodd",
    d: "M6.45 3.773C6.422 2.483 5.495 1.5 3.99 1.5c-1.506 0-2.49.983-2.49 2.273 0 1.263.955 2.274 2.432 2.274h.028c1.535 0 2.49-1.011 2.49-2.274m-.29 4.07h-4.4V21h4.4zm10.803-.309c2.895 0 5.066 1.88 5.066 5.922V21h-4.4v-7.039c0-1.768-.637-2.975-2.23-2.975-1.215 0-1.94.814-2.258 1.6-.116.281-.145.673-.145 1.066V21h-4.4s.058-11.922 0-13.157h4.4v1.864c.585-.896 1.63-2.173 3.967-2.173",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedinLogoV2;